import { defineFetch } from 'resift';

const makeGetOnboardingTasks = defineFetch({
  displayName: 'Get Onboarding Tasks',
  make: () => ({
    request: () => ({ http }) =>
      http({
        method: 'GET',
        route: '/onboarding-tasks',
      }),
  }),
});

const getOnboardingTasks = makeGetOnboardingTasks();

export default getOnboardingTasks;
